import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import { handleValidateObj } from 'constants/objValues/objvalues';
import DatePicker from 'components/sales/datePicker/datePicker';
import { fetchGatesChecklist } from 'services/redux/maintenance/pmList/action';
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import { toast, ToastContainer } from "react-toastify";
import {STATUS} from "../../../../constants/statusConstant";

const GateDuplicateNew = ({
  data,
  id,
  index,
  handleValue,
  imageUploadUrl,
  videoUploadUrl,
  prefilledData,
  gatePhoto,
  isEdit
}) => {
  const { gateSetup, gates_info } = data;
  const gatesInputs = {};
  const gatesPhotos = {};
  const gatesVideos = {};
  const [gatesData, setGatesData] = useState(gatesInputs);
  const [isHardware, setIsHardware] = useState('');
  const [isAmc, setIsAmc] = useState('');
  const [isDamage, setIsDamage] = useState('');
  const [autoFillData, setAutoFillData] = useState();
  const [gatePhotos, setGatePhotos] = useState(gatesPhotos);
  const [gateVideos, setGateVideos] = useState(gatesVideos);
  const [current_name, setCurrent_name] = useState('');
  const [internetAvailabilty, setInternetAvailabilty] = useState('');
  const isloading = [{ name: 'Loding...', id: 1 }];
  const [teamId, setTeamId] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    gatesInputs[`currentSetup_${id}`] = '';
    gatesInputs[`id`] = `${id}`;
    gatesInputs[`userFor_${id}`] = '';
    gatesInputs[`hardwareRemoved_${id}`] = '';
    gatesInputs[`hardwareDtl_${id}`] = '';
    gatesInputs[`internetAvailabilty_${id}`] = '';
    gatesInputs[`timeline_${id}`] = '';
    gatesPhotos[`gatePhotos_${id}`] = '';
    gatesVideos[`gateVideos_${id}`] = '';

    gatesInputs[`amc_${id}`] = '';
    gatesInputs[`installationCost_${id}`] = '';
    gatesInputs[`parkingSlot_${id}`] = '';
    gatesInputs[`basemment_${id}`] = '';

    gatesInputs[`carSlot_${id}`] = '';
    gatesInputs[`bikeSlot_${id}`] = '';
    gatesInputs[`vendorName_${id}`] = '';
    gatesInputs[`sellingCar_${id}`] = '';
    gatesInputs[`purchaseCar_${id}`] = '';
    gatesInputs[`purchaseBike_${id}`] = '';
    gatesInputs[`sellingBike_${id}`] = '';

    gatesInputs[`valetDriver_${id}`] = '';
    gatesInputs[`valetSup_${id}`] = '';
    gatesInputs[`damageLiability_${id}`] = '';
    gatesInputs[`premium_${id}`] = '';
    

    gatesInputs[`softwareCost_${id}`] = '';
    gatesInputs[`SWPaymentType_${id}`] = '';
    gatesInputs[`valetDriverCost_${id}`] = '';
    gatesInputs[`valetSupCost_${id}`] = '';
    gatesInputs[`valetAtt_${id}`] = '';
    gatesInputs[`valetAttCost_${id}`] = '';
    gatesInputs[`managementFee_${id}`] = '';
    gatesInputs[`miscellaneousCost_${id}`] = '';
    gatesInputs[`revenueShare_${id}`] = '';
    gatesInputs[`profit_${id}`] = '';
    gatesInputs[`chargerType_${id}`] = '';
    gatesInputs[`remark_${id}`] = '';
    gatesInputs[`totalAmount_${id}`] = '';

    gatesVideos[`amount_${id}`] = '';
    //ANPR-CAMC
    gatesInputs[`gateCount_${id}`] = '';
    gatesInputs[`optedGateNo_${id}`] = '';
    gatesInputs[`contractValidity_${id}`] = '';
    gatesInputs[`planDate_${id}`] = '';
    gatesInputs[`anprCameraFixed_${id}`] = '';
    gatesInputs[`roiSet_${id}`] = '';
    gatesInputs[`handoverTestingDate_${id}`] = '';
    gatesInputs[`disableOption_${id}`] = '';

  }, []);

  const handleDataValues = (is = false, obj = null) => {
    if (is && obj !== null) {
      handleValue({ ...obj });
    }
  };

  useEffect(() => {
    if (
      prefilledData !== undefined &&
      prefilledData !== null &&
      prefilledData !== ''
    ) {
      const {
        current_setup_id,
        gateName,
        used_for,
        gate_photo,
        any_hardware_removed,
        hardware_details,
        gate_amount,
        internet_availability,
        timeline_internet,
        amc,
        amc_amount,
        installation_cost,
        parking_slot,
        basemment,
        carSlot,
        bikeSlot,
        vendorName,
        sellingCar,
        purchaseCar,
        purchaseBike,
        sellingBike,
        valetDriver,
        valetSup,
        damageLiability,
        premium,
        
        softwareCost,
        SWPaymentType,
        valetDriverCost,
        valetSupCost,
        valetAtt,
        valetAttCost,
        managementFee,
        miscellaneousCost,
        revenueShare,
        profit,
        chargerType,
        remark,
        totalAmount,
        //ANPR-CAMC
        gateCount,
        optedGateNo,
        contractValidity,
        planDate,
        anprCameraFixed,
        roiSet,
        handoverTestingDate,
        disableOption
      } = prefilledData;
      console.log('gcont' + gateCount);
      setGatesData({
        ...gatesData,
        [`currentSetup_${id}`]: current_setup_id,
        [`userFor_${id}`]: used_for,
        userForName: (used_for == '1')
          ? 'Entry'
          : used_for == '2'
            ? 'Exit'
            : used_for == '3'
              ? 'Both'
              : '',
        [`hardwareRemoved_${id}`]: any_hardware_removed,
        [`gate_photo_${id}`]: gate_photo,
        hardwareValue: (any_hardware_removed == 'yes')
          ? 'Yes'
          : 'No',
        [`hardwareDtl_${id}`]: hardware_details,
        hardware_value: hardware_details,


        [`amc_${id}`]: amc,
        amcName: (amc == 'nonComp')
          ? 'Non Comprehensive AMC'
          : amc == 'comp'
            ? 'Comprehensive AMC'
            : amc == 'no'
              ? 'No'
              : '',
        [`amc_amount_${id}`]: amc_amount,
        amc_amount : amc_amount,

        [`installationCost_${id}`]: installation_cost,
        installation_cost : installation_cost,

        [`parkingSlot_${id}`]: parking_slot,
        parking_slot: parking_slot,

        [`basemment_${id}`]: basemment,
        basemment: basemment,

        [`carSlot_${id}`]: carSlot,
        carSlot : carSlot,
        [`bikeSlot_${id}`]: bikeSlot,
        bikeSlot : bikeSlot,
        [`vendorName_${id}`]: vendorName,
        vendorName: vendorName,
        [`sellingCar_${id}`]: sellingCar,
        sellingCar:sellingCar,
        [`purchaseCar_${id}`]: purchaseCar,
        purchaseCar:purchaseCar,
        [`purchaseBike_${id}`]: purchaseBike,
        purchaseBike:purchaseBike,
        [`sellingBike_${id}`]: sellingBike,
        sellingBike:sellingBike,

        [`valetDriver_${id}`]: valetDriver,
        valetDriver:valetDriver,
        [`valetSup_${id}`]: valetSup,
        valetSup:valetSup,
        [`damageLiability_${id}`]: damageLiability,
        [`premium_${id}`]: premium,
        premium:premium,
       
        [`softwareCost_${id}`]: softwareCost,
        softwareCost:softwareCost,
        [`SWPaymentType_${id}`]: SWPaymentType,
        SWPaymentType:SWPaymentType,
        [`valetDriverCost_${id}`]: valetDriverCost,
        valetDriverCost:valetDriverCost,
        [`valetSupCost_${id}`]: valetSupCost,
        valetSupCost:valetSupCost,
        [`valetAtt_${id}`]: valetAtt,
        valetAtt:valetAtt,
        [`valetAttCost_${id}`]: valetAttCost,
        valetAttCost:valetAttCost,
        [`managementFee_${id}`]: managementFee,
        managementFee:managementFee,
        [`miscellaneousCost_${id}`]: miscellaneousCost,
        miscellaneousCost:miscellaneousCost,
        [`revenueShare_${id}`]: revenueShare,
        revenueShare:revenueShare,
        [`profit_${id}`]: profit,
        profit:profit,
        [`remark_${id}`]: remark,
        remark:remark,
        
        [`chargerType_${id}`]: chargerType,
        chargerType:chargerType,
        
        damageLiabilityName: damageLiability ,
        

        [`amount_${id}`]: gate_amount,
        amount: (gate_amount != null) ? gate_amount.toString() : '',

        
        [`totalAmount_${id}`]: totalAmount,
        totalAmount: (totalAmount != null) ? totalAmount.toString() : '',

        [`internetAvailabilty_${id}`]: internet_availability,
        internet_value: (internet_availability == 'yes')
          ? 'Yes'
          : 'No',
        [`timeline_${id}`]: timeline_internet,
        internet_timeline: timeline_internet,
         
        //ANPR-CAMC
        [`gateCount_${id}`]: gateCount,
        gateCount: gateCount,

        [`optedGateNo_${id}`]: optedGateNo,
        optedGateNo: optedGateNo,

        [`contractValidity_${id}`]: contractValidity,
        contractValidity: contractValidity,

        [`planDate_${id}`]: planDate,
        planDate: planDate,

        [`anprCameraFixed_${id}`]: anprCameraFixed,
        anprCameraFixed: anprCameraFixed,

        [`roiSet_${id}`]: roiSet,
        roiSet: roiSet,

        [`handoverTestingDate_${id}`]: handoverTestingDate,
        handoverTestingDate: handoverTestingDate,

        [`disableOption_${id}`]: disableOption,
        disableOption: disableOption,
      });
      // console.log(id);
      fetchGateName(current_setup_id);
      setGatePhotos({ [`gatePhotos_${id}`]: gate_photo });
      setInternetAvailabilty(internet_availability);
      setIsHardware(any_hardware_removed);
      setIsAmc(amc);
      setIsDamage(damageLiability);
      
      // console.log([gatesData]);
    }
  }, [prefilledData]);

  const fetchGateName = async(current_setup_id) =>{
    let url =Config.postSales.getSolution;
    const payload = {
      id:current_setup_id
    };
    const { data } = await axios.post(url, payload);
    if(data.response && data.response.data && data.response.data.name){
      setCurrent_name(data.response.data.name);
    }
    
  }

  useEffect(() => {
   if(gatesData[`currentSetup_${id}`]){
    handledropDownChange(gatesData[`currentSetup_${id}`]);
   }
  },[gatesData[`currentSetup_${id}`]]);

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      const team =
          (await JSON.parse(localStorage.getItem('viewDetail'))) &&
          JSON.parse(localStorage.getItem('viewDetail'))[0].lead_type_id;
      setTeamId(team);
    })();
    setIsLoading(false);
  }, []);

  const handledropDownChange = async (e) => {
    if(e){
     try {
       const url = `${Config.preSalesList.getSolutionQuestion}?solution_id=${e}`;
 
       const { data } = await axios.get(url);
       setAutoFillData(data?.response?.data ?? data?.data)
     } catch {
       toast.error('Something went wrong, Please try again')
     }
    }
   };

  useEffect(() => {
    if (handleValue) {
      const gateObj = {
        [`currentSetup_${id}`]: gatesData[`currentSetup_${id}`],
        // [`userFor_${id}`]: gatesData[`userFor_${id}`],
        // [`hardwareRemoved_${id}`]: gatesData[`hardwareRemoved_${id}`],
        // [`internetAvailabilty_${id}`]: gatesData[`internetAvailabilty_${id}`],
        // [`gatePhotos_${id}`]: gatePhotos[`gatePhotos_${id}`],
        // [`gateVideos_${id}`]: gateVideos[`gateVideos_${id}`],
      };
      const isNotEmpty = handleValidateObj(gateObj);
      const obj = {
        id: id,
        current_setup_id: gatesData[`currentSetup_${id}`],
        used_for: gatesData[`userFor_${id}`],
        gate_photo: gatePhotos[`gatePhotos_${id}`],
        video: gateVideos[`gateVideos_${id}`],
        any_hardware_removed: gatesData[`hardwareRemoved_${id}`],
        hardware_details: gatesData[`hardwareDtl_${id}`],
        internet_availability: gatesData[`internetAvailabilty_${id}`],
        timeline_internet: gatesData[`timeline_${id}`],
        gate_amount: gatesData[`amount_${id}`],
        totalAmount: gatesData[`totalAmount_${id}`],
        
        amc: gatesData[`amc_${id}`],
        amc_amount: gatesData[`amc_amount_${id}`],
        installation_cost: gatesData[`installationCost_${id}`],
        parking_slot: gatesData[`parkingSlot_${id}`],
        basemment : gatesData[`basemment_${id}`],

        carSlot : gatesData[`carSlot_${id}`],
        bikeSlot : gatesData[`bikeSlot_${id}`],
        vendorName : gatesData[`vendorName_${id}`],
        sellingCar : gatesData[`sellingCar_${id}`],
        purchaseCar : gatesData[`purchaseCar_${id}`],
        purchaseBike : gatesData[`purchaseBike_${id}`],
        sellingBike : gatesData[`sellingBike_${id}`],
        

        softwareCost : gatesData[`softwareCost_${id}`],
        SWPaymentType : gatesData[`SWPaymentType_${id}`],
        valetDriverCost : gatesData[`valetDriverCost_${id}`],
        valetSupCost : gatesData[`valetSupCost_${id}`],
        valetAtt : gatesData[`valetAtt_${id}`],
        valetAttCost : gatesData[`valetAttCost_${id}`],
        managementFee : gatesData[`managementFee_${id}`],
        miscellaneousCost : gatesData[`miscellaneousCost_${id}`],
        revenueShare : gatesData[`revenueShare_${id}`],
        profit : gatesData[`profit_${id}`],
        chargerType : gatesData[`chargerType_${id}`],
        remark : gatesData[`remark_${id}`],
        

        valetDriver : gatesData[`valetDriver_${id}`],
        valetSup : gatesData[`valetSup_${id}`],
        damageLiability : gatesData[`damageLiability_${id}`],
        premium : gatesData[`premium_${id}`],

        //ANPR-CAMC
        gateCount: gatesData[`gateCount_${id}`],
        optedGateNo: gatesData[`optedGateNo_${id}`],
        contractValidity: gatesData[`contractValidity_${id}`],
        planDate: gatesData[`planDate_${id}`],
        anprCameraFixed: gatesData[`anprCameraFixed_${id}`],
        roiSet: gatesData[`roiSet_${id}`],
        handoverTestingDate: gatesData[`handoverTestingDate_${id}`],
        disableOption: gatesData[`disableOption_${id}`]
      };
      
      
      if (isNotEmpty !== false) {
        handleDataValues(true, { ...obj });
      } else {
        handleDataValues(false, null);
      }
    }
  }, [gatesData, gatePhotos, gateVideos]);


  const handleAddFields = () => {
    return (
      <div className="">
        <div className='col-md-12'>
        <DropDownInput
          data={gateSetup?.type ? gateSetup.type : isloading}
          label={localization.desiredSetup}
          getIdValue={(val) =>{
            setGatesData({ ...gatesData, [`currentSetup_${id}`]: val.id });
            handledropDownChange(val.id);
          }   
          }
          value={
            gatesData[`currentSetup_${id}`]?.value
              ? gatesData[`currentSetup_${id}`]?.value
              : current_name
          }
          required
          isStarRequired={true}
          errorMsg={localization.requiredcurrentSetup}
        />
        </div>
        {autoFillData ?
          <>
            {autoFillData.includes('entry_type') ?
            <div className='col-md-6'>
              <DropDownInput
              data={gateSetup?.userFor ? gateSetup.userFor : isloading}
              label={localization.usedFor}
              getIdValue={(val) =>
                setGatesData({ ...gatesData, [`userFor_${id}`]: val.id })
              }
              // value={
              //   gatesData[`userFor_${id}`]?.value
              //     ? gatesData[`userFor_${id}`]?.value
              //     : current_name
              // }
              required={
                (current_name === 'None' || current_name === 'none') ? false : true
              }
              isStarRequired={
                current_name === 'None' || current_name === 'none' ? false : true
              }
              errorMsg={localization.isRequired}
              value={gatesData?.userForName}
            />
            </div>
            :
            null
            }
            
            {autoFillData.includes('any_hardware') ?
              <>
              <div className='col-md-6'>
              <DropDownInput
                data={
                  gateSetup?.anyHardwareRemoved
                    ? gateSetup.anyHardwareRemoved
                    : isloading
                }
                label={localization.hardwareRemoved}
                getIdValue={(val) => {
                  setGatesData({ ...gatesData, [`hardwareRemoved_${id}`]: val.id });
                  setIsHardware(val.value);
                }}
                required={
                  (current_name === 'None' || current_name === 'none') ? false : true
                }
                isStarRequired={
                  current_name === 'None' || current_name === 'none' ? false : true
                }
                // value={(current_name === 'None' || current_name === 'none') ? 'No' : ''}
                errorMsg={localization.isRequired}
                value={gatesData?.hardwareValue}
              />
              </div>
              {isHardware?.toLowerCase() === 'yes' && (
                <div className='col-md-6'>
                <ConstantInput
                  label={localization.hardwareDtl}
                  handleChange={(val) =>
                    setGatesData({ ...gatesData, [`hardwareDtl_${id}`]: val })
                  }
                  value={gatesData?.hardware_value}
                />
                </div>
              )}
              
              </>
              :
              null
            }
        {console.log(autoFillData)}
          {/* NEW FIELD START */}
          {autoFillData.includes('amc') ?
              <>
              <div className='col-md-6'>
                <DropDownInput
                  data={
                    gateSetup?.amc
                      ? gateSetup.amc
                      : isloading
                  }
                  label={localization.amc}
                  getIdValue={(val) => {
                    setGatesData({ ...gatesData, [`amc_${id}`]: val.id });
                    setIsAmc(val.value);
                  }}
                  required={
                    (current_name === 'None' || current_name === 'none') ? false : true
                  }
                  isStarRequired={
                    current_name === 'None' || current_name === 'none' ? false : true
                  }
                  // value={(current_name === 'None' || current_name === 'none') ? 'No' : ''}
                  errorMsg={localization.isRequired}
                  value={gatesData?.amcName}
                />
                </div>
                {(isAmc?.toLowerCase() === 'no' || isAmc?.toLowerCase() === '') ?
                null
                :
                (
                  <div className='col-md-6'>
                  <ConstantInput
                    label={localization.amcAmount}
                    type="number"
                    min={0}
                    handleChange={(val) =>
                      setGatesData({ ...gatesData, [`amc_amount_${id}`]: val })
                    }
                    value={gatesData?.amc_amount}
                  />
                  </div>
                )}
              </>
              :null
            }
            
          {autoFillData.includes('installation_cost') ?   
          <div className='col-md-6'>
            <ConstantInput
              label={localization.installationCost}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`installationCost_${id}`]: val })
              }
              type="number"
              min={0}
              required
              isStarRequired
              errorMsg={localization.installationCost}
              value={gatesData?.installation_cost}
            />
            </div>
            : null
          }
          {autoFillData.includes('parking_slot') ?   
          <div className='col-md-6'>
            <ConstantInput
              label={localization.parkingSlot}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`parkingSlot_${id}`]: val })
              }
              type="number"
              min={0}
              required
              isStarRequired
              errorMsg={localization.parkingSlot}
              value={gatesData?.parking_slot}
            />
            </div>
            :null
          }
        
          {autoFillData.includes('basemment')||autoFillData.includes('basement') ?  
          <div className='col-md-6'>
            <ConstantInput
              label={localization.basemment}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`basemment_${id}`]: val })
              }
              type="number"
              min={0}
              required
              isStarRequired
              errorMsg={localization.basemment}
              value={gatesData?.basemment}
            />
            </div>
            : null
          }
          {autoFillData.includes('car_slot') ?  
          <div className='col-md-6'>
            <ConstantInput
              label={localization.carSlot}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`carSlot_${id}`]: val })
              }
              type="number"
              min={0}
              required
              isStarRequired
              errorMsg={localization.carSlot}
              value={gatesData?.carSlot}
            />
            </div>
            : null 
          }
          {autoFillData.includes('bike_slot') ?  
          <div className='col-md-6'>
            <ConstantInput
              label={localization.bikeSlot}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`bikeSlot_${id}`]: val })
              }
              type="number"
              min={0}
              required
              isStarRequired
              errorMsg={localization.bikeSlot}
              value={gatesData?.bikeSlot}
            />
            </div>
            : null
          }
          {autoFillData.includes('vendor') ? 
          <div className='col-md-6'>
            <ConstantInput
              label={localization.vendorName}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`vendorName_${id}`]: val })
              }
              min={0}
              required
              isStarRequired
              errorMsg={localization.vendorName}
              value={gatesData?.vendorName}
            />
            </div>
            : null
          }
          {autoFillData.includes('purchase_car_slot') ? 
          <div className='col-md-6'>
            <ConstantInput
              label={localization.purchaseCar}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`purchaseCar_${id}`]: val })
              }
              type="number"
              min={0}
              required
              isStarRequired
              errorMsg={localization.purchaseCar}
              value={gatesData?.purchaseCar}
            />
            </div>
            : null
          }
          {autoFillData.includes('sale_car_slot') ? 
          <div className='col-md-6'>
            <ConstantInput
              label={localization.sellingCar}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`sellingCar_${id}`]: val })
              }
              type="number"
              min={0}
              required
              isStarRequired
              errorMsg={localization.sellingCar}
              value={gatesData?.sellingCar}
            />
            </div>
            : null
          }
          {autoFillData.includes('purchase_bike_slot') ? 
          <div className='col-md-6'>
            <ConstantInput
              label={localization.purchaseBike}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`purchaseBike_${id}`]: val })
              }
              type="number"
              min={0}
              required
              isStarRequired
              errorMsg={localization.purchaseBike}
              value={gatesData?.purchaseBike}
            />
            </div>
            : null
          }
          {autoFillData.includes('sale_bike_slot') ? 
          <div className='col-md-6'>
            <ConstantInput
              label={localization.sellingBike}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`sellingBike_${id}`]: val })
              }
              type="number"
              min={0}
              required
              isStarRequired
              errorMsg={localization.sellingBike}
              value={gatesData?.sellingBike}
            />
            </div>
            : null
          }
          {autoFillData.includes('Valet_driver') ? 
          <div className='col-md-6'>
            <ConstantInput
              label={localization.valetDriver}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`valetDriver_${id}`]: val })
              }
              type="number"
              min={0}
              required
              isStarRequired
              errorMsg={localization.valetDriver}
              value={gatesData?.valetDriver}
            />
            </div>
            : null
          }
          {autoFillData.includes('valet_sup') ? 
          <div className='col-md-6'>
            <ConstantInput
              label={localization.valetSup}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`valetSup_${id}`]: val })
              }
              type="number"
              min={0}
              required
              isStarRequired
              errorMsg={localization.valetSup}
              value={gatesData?.valetSup}
            />
            </div>
            : null
          }
         
         {autoFillData.includes('software_cost') ? 
         <div className='col-md-6'>
                          <ConstantInput
                            label={localization.software_cost}
                            handleChange={(val) =>
                              setGatesData({ ...gatesData, [`softwareCost_${id}`]: val })
                            }
                            type="number"
                            min={0}
                            required
                            isStarRequired
                            errorMsg={localization.software_cost}
                            value={gatesData?.softwareCost}
                          />
                          </div>
                          : null
                        }
              {autoFillData.includes('sw_payment_type') ?
              <>
              <div className='col-md-6'>
              <DropDownInput
                data={
                  gateSetup?.Damage_Liability
                    ? gateSetup.Damage_Liability
                    : isloading
                }
                label={localization.SWPaymentType}
                getIdValue={(val) => {
                  setGatesData({ ...gatesData, [`SWPaymentType_${id}`]: val.id });
                }}
                required={
                  (current_name === 'None' || current_name === 'none') ? false : true
                }
                isStarRequired={
                  current_name === 'None' || current_name === 'none' ? false : true
                }
                // value={(current_name === 'None' || current_name === 'none') ? 'No' : ''}
                errorMsg={localization.isRequired}
                value={gatesData?.SWPaymentType}
              />
              </div>
              </>
              : null
            }


            {autoFillData.includes('damage') ?
              <>
              <div className='col-md-6'>
              <DropDownInput
                data={
                  gateSetup?.Damage_Liability
                    ? gateSetup.Damage_Liability
                    : isloading
                }
                label={localization.damageLiability}
                getIdValue={(val) => {
                  setGatesData({ ...gatesData, [`damageLiability_${id}`]: val.id });
                  setIsDamage(val.value);
                }}
                required={
                  (current_name === 'None' || current_name === 'none') ? false : true
                }
                isStarRequired={
                  current_name === 'None' || current_name === 'none' ? false : true
                }
                // value={(current_name === 'None' || current_name === 'none') ? 'No' : ''}
                errorMsg={localization.isRequired}
                value={gatesData?.damageLiabilityName}
              />
              </div>
              {(isDamage === 'No' || isDamage === '') ?
              null
              :
              (
                <div className='col-md-6'>
                <ConstantInput
                  label={localization.premium}
                  type="number"
                  min={0}
                  handleChange={(val) =>
                    setGatesData({ ...gatesData, [`premium_${id}`]: val })
                  }
                  value={gatesData?.premium}
                />
                </div>
              )}
              </>
              : null
            }


            {autoFillData.includes('charger_type') ?
                          <>
                          <div className='col-md-6'>
                          <DropDownInput
                            data={
                              gateSetup?.EV_Charger
                                ? gateSetup.EV_Charger
                                : isloading
                            }
                            label={localization.charger_type}
                            getIdValue={(val) => {
                              setGatesData({ ...gatesData, [`chargerType_${id}`]: val.id });
                            }}
                            required={
                              (current_name === 'None' || current_name === 'none') ? false : true
                            }
                            isStarRequired={
                              current_name === 'None' || current_name === 'none' ? false : true
                            }
                            // value={(current_name === 'None' || current_name === 'none') ? 'No' : ''}
                            errorMsg={localization.isRequired}
                            value={gatesData?.chargerType}
                          />
                          </div>
                          </>
                          : null
                        }

            {autoFillData.includes('valet_driver_cost') ? 
            <div className='col-md-6'>
                        <ConstantInput
                          label={localization.valet_driver_cost}
                          handleChange={(val) =>
                            setGatesData({ ...gatesData, [`valetDriverCost_${id}`]: val })
                          }
                          type="number"
                          min={0}
                          // required
                          // isStarRequired
                          errorMsg={localization.valetSup}
                          value={gatesData?.valetDriverCost}
                        />
                        </div>
                        : null
                      }
            {autoFillData.includes('valet_sup_cost') ? 
            <div className='col-md-6'>
                        <ConstantInput
                          label={localization.valet_sup_cost}
                          handleChange={(val) =>
                            setGatesData({ ...gatesData, [`valetSupCost_${id}`]: val })
                          }
                          type="number"
                          min={0}
                          // required
                          // isStarRequired
                          errorMsg={localization.valetSup}
                          value={gatesData?.valetSupCost}
                        />
                        </div>
                        : null
                      }
            {autoFillData.includes('valet_attendant') ? 
            <div className='col-md-6'>
              <ConstantInput
                label={localization.valet_attendant}
                handleChange={(val) =>
                  setGatesData({ ...gatesData, [`valetAtt_${id}`]: val })
                }
                type="number"
                min={0}
                // required
                // isStarRequired
                errorMsg={localization.valet_attendant}
                value={gatesData?.valetAtt}
              />
              </div>
              : null
            }
            {autoFillData.includes('valet_attendent_cost') ? 
            <div className='col-md-6'>
              <ConstantInput
                label={localization.valet_attendent_cost}
                handleChange={(val) =>
                  setGatesData({ ...gatesData, [`valetAttCost_${id}`]: val })
                }
                type="number"
                min={0}
                // required
                // isStarRequired
                errorMsg={localization.valet_attendent_cost}
                value={gatesData?.valetAttCost}
              />
            </div>
              : null
            }
            {autoFillData.includes('management_fee') ? 
            <div className='col-md-6'>
              <ConstantInput
                label={localization.management_fee}
                handleChange={(val) =>
                  setGatesData({ ...gatesData, [`managementFee_${id}`]: val })
                }
                type="number"
                min={0}
                // required
                // isStarRequired
                errorMsg={localization.management_fee}
                value={gatesData?.managementFee}
              />
              </div>
              : null
            }
            {autoFillData.includes('miscellaneous_cost') ? 
            <div className='col-md-6'>
              <ConstantInput
                label={localization.miscellaneous_cost}
                handleChange={(val) =>
                  setGatesData({ ...gatesData, [`miscellaneousCost_${id}`]: val })
                }
                type="number"
                min={0}
                // required
                // isStarRequired
                errorMsg={localization.miscellaneous_cost}
                value={gatesData?.miscellaneousCost}
              />
              </div>
              : null
            }
            {autoFillData.includes('revenue_share') ? 
            <div className='col-md-6'>
              <ConstantInput
                label={localization.revenue_share}
                handleChange={(val) =>
                  setGatesData({ ...gatesData, [`revenueShare_${id}`]: val })
                }
                type="number"
                min={0}
                // required
                // isStarRequired
                errorMsg={localization.revenue_share}
                value={gatesData?.revenueShare}
              />
              </div>
              : null
            }
            {autoFillData.includes('profit_share') ? 
            <div className='col-md-6'>
              <ConstantInput
                label={localization.profit_share}
                handleChange={(val) =>
                  setGatesData({ ...gatesData, [`profit_${id}`]: val })
                }
                type="number"
                min={0}
                // required
                // isStarRequired
                errorMsg={localization.profit_share}
                value={gatesData?.profit}
              />
              </div>
              : null
            }
         
         {autoFillData.includes('remark') ? 
         <div className='col-md-6'>
                        <ConstantInput
                          label={localization.remark}
                          handleChange={(val) =>
                            setGatesData({ ...gatesData, [`remark_${id}`]: val })
                          }
                          min={0}
                          
                          errorMsg={localization.remark}
                          value={gatesData?.remark}
                        />
                        </div>
                        : null
                      }

          {/* NEW FIELD */}
          {(autoFillData.includes('amount') && teamId !== STATUS.SUPPLY) ?
          <div className='col-md-6'>
            <ConstantInput
              label={`${data?.commercialData?.commercial_type_id == 7 ? localization.gateMonthlyRentalAmount : localization.gateAmount}`}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`amount_${id}`]: val })
              }
              type="number"
              min={0}
              required
              isStarRequired
              errorMsg={localization.requiredGateAmount}
              value={gatesData?.amount}
            />
            </div>
            : null
           }

              {autoFillData.includes('total_amount') ?
              <div className='col-md-6'>
                        <ConstantInput
                          label={localization.amountgateAmt}
                          handleChange={(val) =>
                            setGatesData({ ...gatesData, [`totalAmount_${id}`]: val })
                          }
                          type="number"
                          min={0}
                          required
                          isStarRequired
                          placeholder='Amount of Gate + AMC per Month'
                          errorMsg={localization.amount}
                          value={gatesData?.totalAmount}
                        />
                        </div>
                        : null
                      }

          {autoFillData.includes('amount') ?
          <>
          <div className='col-md-6'>
            {/* <strong className="d-block w-100 my-3">
              {localization.internetDetails}
            </strong> */}
            <DropDownInput
              data={
                gateSetup?.internetAvailaibility
                  ? gateSetup.internetAvailaibility
                  : isloading
              }
              label={localization.internetAvailabilty}
              isBottom
              getIdValue={(val) => {
                setGatesData({
                  ...gatesData,
                  [`internetAvailabilty_${id}`]: val.id,
                });
                setInternetAvailabilty(val.value);
              }}
              required={
                (current_name === 'None' || current_name === 'none') ? false : true
              }
              isStarRequired={
                current_name === 'None' || current_name === 'none' ? false : true
              }
              value={gatesData?.internet_value}
              // value={(current_name === 'None' || current_name === 'none') ? 'Yes' : ''}
              errorMsg={localization.requiredinternetAvailabilty}
            />
            </div>
            {internetAvailabilty?.toLowerCase() === 'no' ? (
              <div className='col-md-6'>
              <DatePicker
                handleChange={(val) => {
                  setGatesData({ ...gatesData, [`timeline_${id}`]: val });
                }}
                label={localization.timeline}
                minDate={new Date()}
                value={gatesData?.internet_timeline}
              />
              </div>
            ) : null}
            </>
            : null
          }

          {/* ANPR and CAMC Questions */}
          {autoFillData.includes('gate_count') ?
          <>
          <div className='col-md-6'>
          <ConstantInput
              label={localization.gateCount}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`gateCount_${id}`]: val })
              }
              type="number"
              min={0}
              required
              isStarRequired
              //errorMsg={localization.amount}
              value={gatesData?.gateCount}
            />  
            </div>
          </>
          : null}
          {autoFillData.includes('opted_gate_no') ?
          <>
          <div className='col-md-6'>
          <ConstantInput
              label={localization.optedGateNo}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`optedGateNo_${id}`]: val })
              }
              type="number"
              min={0}
              required
              isStarRequired
              //errorMsg={localization.amount}
              value={gatesData?.optedGateNo}
            />  
            </div>
          </>
          : null}
          {autoFillData.includes('contract_validity') ?
          <>
          <div className='col-md-6'>
          <ConstantInput
              label={localization.contractValidity}
              handleChange={(val) =>
                setGatesData({ ...gatesData, [`contractValidity_${id}`]: val })
              }
              type="number"
              min={0}
              required
              isStarRequired
              //errorMsg={localization.amount}
              value={gatesData?.contractValidity}
            />  
            </div>
          </>
          : null}
          {autoFillData.includes('plan_date') ?
          <>
          <div className='col-md-6'>
          <DatePicker
                handleChange={(val) => {
                  setGatesData({ ...gatesData, [`planDate_${id}`]: val });
                }}
                label={localization.planDate}
                minDate={new Date()}
                value={gatesData?.planDate}
              />  
              </div>
          </>
          : null}
          {autoFillData.includes('anpr_camera_fixed') ?
          <>
          <div className='col-md-6'>
          <DropDownInput
              data={[
                {id: 'Yes', name: 'Yes'},
                {id: 'No', name: 'No'}
              ]}
              getIdValue={(val) => {
                setGatesData({ ...gatesData, [`anprCameraFixed_${id}`]: val.id });
              }}
              label={localization.anprCameraFixed}
              value={gatesData?.anprCameraFixed}
            /> 
            </div>
          </>
          : null}
          {autoFillData.includes('roi_set') ?
          <>
          <div className='col-md-6'>
          <DropDownInput
              data={[
                {id: 'Yes', name: 'Yes'},
                {id: 'No', name: 'No'}
              ]}
              getIdValue={(val) => {
                setGatesData({ ...gatesData, [`roiSet_${id}`]: val.id });
              }}
              label={localization.roiSet}
              value={gatesData?.roiSet}
            /> 
            </div>
          </>
          : null}
          {autoFillData.includes('handover_testing_date') ?
          <>
          <div className='col-md-6'>
          <DatePicker
                handleChange={(val) => {
                  setGatesData({ ...gatesData, [`handoverTestingDate_${id}`]: val });
                }}
                label={localization.handOverDate}
                minDate={new Date()}
                value={gatesData?.handoverTestingDate}
              /> 
              </div> 
          </>
          : null}
          {autoFillData.includes('disable_option') ?
          <>
          <div className='col-md-6'>
          <DropDownInput
              data={[
                {id: 'Active', name: 'Active'},
                {id: 'Inactive', name: 'Inactive'}
              ]}
              getIdValue={(val) => {
                setGatesData({ ...gatesData, [`disableOption_${id}`]: val.id });
              }}
              label={localization.disableOption}
              value={gatesData?.disableOption}
            /> 
            </div>
          </>
          : null}
          {/* ANPR and CAMC Questions End */}

          <div className="w-100">
          {/* <div className="btn-transparent mr-3 d-inline-block">
            <FileUpload
              documentUploadUrl={imageUploadUrl}
              id={`uploadGatePhotos-${id}`}
              required={
                (current_name === 'None' || current_name === 'none') ? false : true
              }
              multiple
              onChange={(val) => {
                setGatePhotos({ [`gatePhotos_${id}`]: val.toString() });
              }}
            >
              <span className="btn btn-transparent">
                {localization.uploadGatePhotos}
              </span>
            </FileUpload>
          </div> */}
          {/* <div className="btn-transparent mr-3 d-inline-block">
            <FileUpload
              id={`uploadGateVideos-${id}`}
              required={
                (current_name === 'None' || current_name === 'none') ? false : true
              }
              documentUploadUrl={videoUploadUrl}
              accept="video/*"
              onChange={(val) => {
                setGateVideos({ [`gateVideos_${id}`]: val.toString() });
              }}
            >
              <span className="btn btn-transparent">
                {localization.uploadGateVideos}
              </span>
            </FileUpload>
          </div> */}

        </div>

          </>
        :
          <>
          <br/><br/>
          <br/><br/>
          </>
        }
        
        
      </div>
    );
  }

  return (
    <Fragment key={id}>
      {handleAddFields()}
    </Fragment>

  );
};
GateDuplicateNew.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};
export default GateDuplicateNew;
